module.exports = __webpack_public_path__ + "static/media/REVERSI-2.41685c10.png";